( function ( _s ) {
	_s.fn.searchForm = function () {
		return this.each( searchForm => {
			const _searchForm = _s( searchForm );
			const _toggle = _searchForm.find( '.search-toggle' );
			const _searchInput = _searchForm.find( '[type="search"]' );
			const isDesktopHeaderSearchForm = _searchForm.closest( '.navbar-desktop' ).length;

			const toggle = () => {
				_searchForm.toggleClass( 'show-form' );
			};

			const hide = () => {
				_searchForm.removeClass( 'show-form' );
			};

			if ( isDesktopHeaderSearchForm ) {
				_toggle.on( 'click', () => {
					toggle();
				} );

				_toggle.on( 'keyup', e => {
					if ( e.key === 'Enter' ) {
						toggle();
					}
				} );

				_s( window ).on( 'fr:shop-donate-dropdown-expanded', () => {
					hide();
				} );

				_s( window ).on( 'fr:body-click', e => {
					const _target = _s( e.detail.event.target );

					if ( ! _searchForm.contains( _target ) ) {
						hide();
					}
				} );
			}
		} );
	};

	_s( document ).ready( () => {
		_s( '.fr-search-form' ).searchForm();
	} );
} )( window._s );
